import * as CONST from '../const';
import UICommon from './common';
class UIFixedPrice {
    owner;
    project;
    el = document.createElement('span');
    constructor(owner, project) {
        this.owner = owner;
        this.project = project;
        project.on('total.changed', (val) => this.updatePrice(val));
    }
    render() {
        this.el.innerHTML = `<a href="#${this.owner.getTargetId()}" class="${CONST.CLASS_PREFIX}price">10000</a>`;
        this.el.id = 'fixed_total_price';
        let cont = this.owner.getQuery().container('main');
        if (cont) {
            cont.appendChild(this.el);
        }
    }
    updatePrice(val) {
        let link = this.el.querySelector('a');
        if (link) {
            link.innerHTML = UICommon.formatPrice(val);
        }
    }
}
export default UIFixedPrice;
